module.exports = __webpack_public_path__ + "img/selected3-min.44d90b68.png";